import { render } from "./FuncPage.vue?vue&type=template&id=ce8767ec"
import script from "./FuncPage.vue?vue&type=script&lang=js"
export * from "./FuncPage.vue?vue&type=script&lang=js"

import "./FuncPage.vue?vue&type=style&index=0&id=ce8767ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__